import Image from 'next/image';
import { Component, ImageWithSrc } from '@headless-workspace/typings';
import { GlowClickable, GlowImage, GlowTextBody } from '../../../../src';

type GlowReinsuranceListItemProps = {
    image: ImageWithSrc;
    title: string;
    description: string;
    cta: {
        href: string;
        label: string;
    };
};

const IMAGE_SIZE = 32;

export const GlowReinsuranceListItem: Component<GlowReinsuranceListItemProps> = ({
    image,
    title,
    description,
    cta,
}) => {
    return (
        <li className={'flex flex-row gap-0.5 w-full'}>
            <span className={'p-0.375'}>
                <GlowImage
                    image={image}
                    loading={'lazy'}
                    className={'min-h-iconLarge min-w-iconLarge'}
                    width={IMAGE_SIZE}
                    height={IMAGE_SIZE}
                    TagName={Image}
                />
            </span>
            <div className={'flex flex-col gap-0.5'}>
                <div>
                    <GlowTextBody text={title} fontWeight={'bold'} className={'line-clamp-1'} />
                    <GlowTextBody text={description} className={'line-clamp-2'} />
                </div>

                <GlowClickable
                    href={cta.href}
                    content={{
                        labelElement: (
                            <GlowTextBody text={cta.label} textDecoration={'underline'} className={'line-clamp-2'} />
                        ),
                    }}
                />
            </div>
        </li>
    );
};
